import { Navigate, Route } from 'react-router-dom'
import { ALLOCATION_PLANS_ROUTE_SEGMENTS, ALLOCATION_PLANS_ROUTES } from './allocationPlansRoutePaths'
import LumpsumPlansPage from '../lumpsum/plans-list/LumpsumPlansPage'
import SipPlansPage from '../sip/plans-list/SipPlansPage'

export const AllocationPlansRoutes = () => {
  return [
    <Route key="allocation-plans-v4" path={ALLOCATION_PLANS_ROUTES.root}>
      <Route index element={<Navigate to={ALLOCATION_PLANS_ROUTES.lumpsum} replace />} />
      <Route path={ALLOCATION_PLANS_ROUTE_SEGMENTS.lumpsum} element={<LumpsumPlansPage />} />
      <Route path={ALLOCATION_PLANS_ROUTE_SEGMENTS.sip} element={<SipPlansPage />} />
    </Route>
  ]
}
